/**
 * Helper: Format metafield richtexts or metaobject richtexts
 * -----------------------------------------------------------------------------
 * Formats richtext into usable html.
 * - according to this formatting:
 * https://shopify.dev/docs/apps/build/custom-data/metafields/list-of-data-types#rich-text-formatting
 *
 * @param {JSON} json - Metaobject json.
 * @returns {String}
 *
 */

export function formatRichtext(json) {
  const parsed = JSON.parse(json);
  let html = '';
  parsed.children.forEach((node) => {
    switch (node.type) {
      case 'heading':
        html += `<h${node.level}>${node.children[0].value}</h${node.level}>`;
        break;
      case 'list':
        html += `<${node.listType === 'unordered' ? 'ul' : 'ol'}>`;
        node.children.forEach((item) => {
          html += `<li>${item.children[0].value}</li>`;
        });
        html += `<${node.listType === 'unordered' ? '/ul' : '/ol'}>`;
        break;
      case 'paragraph':
        html += `<p>`;
        node.children.forEach((item) => {
          if (item.type === 'text') {
            if (item.bold) {
              html += `<strong>${item.value}</strong> `;
            } else if (item.italic) {
              html += `<em>${item.value}</em> `;
            } else {
              html += `${item.value} `;
            }
          }
          if (item.type === 'link' && item.bold) {
            html +=
              `<a href="${item.url}" target="${item.target}"><strong>${item.children[0].value}</strong></a>` +
              ' ';
          } else if (item.type === 'link' && item.italic) {
            html +=
              `<a href="${item.url}" target="${item.target}"><em>${item.children[0].value}</em></a>` +
              ' ';
          } else if (item.type === 'link') {
            html +=
              `<a href="${item.url}" target="${item.target}">${item.children[0].value}</a>` +
              ' ';
          }
        });
        html += `</p>`;
        break;
    }
  });
  return html;
}

/**
 * Fetches an SVG from a URL and turns it into a svg code
 * via XMLHttpRequest it returns quickest without delay.
 *
 * @param {string} svgUrl - The URL of the SVG file.
 */
export function formatSvg(svgUrl) {
  const request = new XMLHttpRequest();
  // `false` makes the request synchronous (blocking)
  request.open('GET', svgUrl, false);
  request.send(null);

  if (request.status === 200) {
    return request.responseText;
  }
  throw new Error(`Failed to fetch SVG: ${request.statusText}`);
}
